<template>
  <div>
    <el-dialog
      title="上传"
      center
      :visible.sync="dialogVisible.show"
      :destroy-on-close="true"
      append-to-body
      @open="openDialog"
      width="30%"
      >
      <el-form label-position="left" :rules="rules" ref="ruleForm" label-width="80px" :model="formData">
        <el-form-item label="项目名称"  prop="projectName">
          <el-input v-model="formData.projectName"></el-input>
        </el-form-item>
        <el-form-item label="项目文件" prop="filePath">
          <el-upload
            class="upload-demo"
            drag
            action="/api/monitor/fileUpload/uploadImage"
            multiple
            :limit="1"
            :on-success="successFile"
            :on-remove="removeFile"
            :file-list="fileList"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
          </el-upload>
        </el-form-item>
      </el-form>


      <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible.show = false">取 消</el-button>
    <el-button type="primary" @click="addSubmit('ruleForm')">确 定</el-button>
  </span>
    </el-dialog>
  </div>
</template>

<script>
    export default {
        name: "uploadFile",
        props:{
            dialogVisible:Object
        },
        data(){
            return{
                rules: {
                    projectName: [
                        { required: true, message: '请输入项目名称', trigger: 'blur' },
                    ],
                    filePath: [
                        { required: true, message: '请添加项目文件', trigger: 'blur' },
                    ]
                },
                fileList:[],
                formData:{
                    projectName:"",
                    filePath:""
                }
            }
        },
        created() {
            // console.log(this.dialogVisible)
        },
        methods:{
            openDialog(){
                // console.log(41111)
            },
            //上传文件fileUpload/uploadImage projectName  filePath fileUpload/addFileData
            successFile(file){
                if(file.status==200){
                    this.formData.filePath=file.datas.values
                    this.$message.success('文件上传成功')
                }else{
                    this.$message.error(file.message)
                }
            },
            removeFile(file){
                if(file.status=='success'){
                    this.formData.filePath=''
                    this.$message.success('文件删除成功')
                }else{
                    this.$message.error(file.message)
                }
            },
            addSubmit(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.$axios.post('/api/monitor/fileUpload/addFileData',this.formData).then(res=>{
                           if(res.data.status==200){
                               this.$message.success('上传成功')
                               this.$emit('getData')
                               this.formData.projectName=''
                               this.formData.filePath=''
                               this.dialogVisible.show=false
                           }else{
                               this.$message.error(res.data.datas.values)
                           }

                        })
                    } else {
                       this.$message.warning('请检查必填项')
                    }
                });
            },
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/project/dialog/uploadFile.vue